import type { ICompanyRepository } from '../domain/ICompanyRepository'
import type { Company } from '../domain/company'

export class GetCompanyDetailUseCase {
    private companyRepository: ICompanyRepository

    constructor(companyRepository: ICompanyRepository) {
        this.companyRepository = companyRepository
    }

    async execute(id: number): Promise<Company> {
        if (isNaN(id) || id <= 0) {
            throw new Error(
                'El ID de la empresa es requerido y debe ser un número válido'
            )
        }

        const companyDetails = await this.companyRepository.getById(id)
        return {
            id: companyDetails.id,
            name: companyDetails.name,
            address: companyDetails.address,
            phone: companyDetails.phone ?? '',
            warehouses: Array.isArray(companyDetails.warehouses)
                ? companyDetails.warehouses
                : [],
            created_at: companyDetails.created_at,
            updated_at: companyDetails.updated_at,
        }
    }
}
